import { render, staticRenderFns } from "./dummy-data.vue?vue&type=template&id=7ea777d4&scoped=true"
import script from "./dummy-data.vue?vue&type=script&lang=js"
export * from "./dummy-data.vue?vue&type=script&lang=js"
import style0 from "./dummy-data.vue?vue&type=style&index=0&id=7ea777d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea777d4",
  null
  
)

export default component.exports